import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { getTenantDetailsActionHandler } from "../../store/actions/actionHandlers/loginActionHandler";
import LoginLayout from "../../components/Common/LoginLayout/LoginLayout";
import setAndGetLocalLang from "../../utils/setAndGetLocalLang";
import { getTenantNameActionHandler } from "../../store/actions/actionHandlers/commonActionHandler";
import getTenantName from "../../utils/getTenantName";
import { setTenantNameAction } from "../../store/actions/actionCreators/commonActionCreator";

const LoginPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const tenantName = getTenantName(dispatch, location);

  useEffect(() => {
    const tenantNameFromLocal = localStorage.getItem("tenantName");
    if (!tenantNameFromLocal) {
      dispatch(getTenantDetailsActionHandler(tenantName, ""));
    }
  }, [dispatch, tenantName]);

  useEffect(() => {
    let tenantNameFromStore = dispatch(getTenantNameActionHandler());

    if (!tenantNameFromStore) {
      localStorage.setItem(
        "tenantName",
        params?.tenantName || location.pathname.split("/")[1]
      );
      dispatch(
        setTenantNameAction(
          params?.tenantName || location.pathname.split("/")[1]
        )
      );
    }
    if (location.pathname === `/${tenantNameFromStore}`) {
      navigate(`/${tenantNameFromStore}/login`);
    }
  }, [location.pathname, params?.tenantName, navigate, dispatch]);

  useEffect(() => {
    if (
      localStorage.getItem("languageTerm") === null ||
      localStorage.getItem("language") === null
    ) {
      setAndGetLocalLang("en-GB", "English", dispatch);
    }
  }, [dispatch]);

  return (
    <div>
      <LoginLayout />
    </div>
  );
};

export default LoginPage;
